import * as types from 'constants/action_types'
import * as pages from 'constants/pages'

const reducers = {}

export const defaultState = {
  toVisible: true,
  ccVisible: false,
  bccVisible: false,
  subjectVisible: false,
  pendingAutofocusRow: null,
  isFocused: false,
}
reducers[pages.NEW_CONVERSATION_PAGE] = () => defaultState
reducers[pages.LOG_CONVERSATION_PAGE] = () => defaultState

// DEPRECATED. We now drive the isBlahVisible off of the `show=blah` search query
reducers[types.SHOW_REPLY_FORM_ROW] = (state, action) => {
  const { type, autofocus } = action.data
  const visibleKey = `${type}Visible`
  const newState = {
    ...state,
    [visibleKey]: true,
  }
  if (autofocus) {
    newState.pendingAutofocusRow = type
  }
  return newState
}

reducers[types.COMPLETE_PENDING_AUTOFOCUS_REPLY_FORM_ROW] = state => {
  return {
    ...state,
    pendingAutofocusRow: null,
  }
}

reducers[types.CHANGE_REPLY_FORM_FOCUS] = (state, action) => {
  return {
    ...state,
    isFocused: action.payload.isFocused,
  }
}

export default function reducer(state = defaultState, action) {
  const handler = reducers[action.type]
  if (handler) return handler(state, action)
  return state
}
